export enum SlideDirection {
  Left = 'left',
  Right = 'right',
  None = 'none',
}
